module.exports = __webpack_public_path__ + "img/instagram.5ee9fbd4.svg";